export default "__VITE_ASSET__CfEBJ_XO__"